import gql from 'graphql-tag';

const VALIDATE_PRODUCT = gql`
  query validateProduct($upc: String!) {
    validateProduct(upc: $upc) {
      productCode
      upc
      pieces
    }
  }
`;

const CREATE_LOCATION_COUNTING = gql`
  mutation createLocationCounting($data: CreateLocationCountingInput!) {
    createLocationCounting(data: $data) {
      id
    }
  }
`;

const GET_ENABLED_LOCATIONS = gql`
  query enabledLocations {
    enabledLocations {
      location {
        id
        tag
      }
      status
      versions
    }
  }
`;

const GET_LATEST_VERSION = gql`
  query incidences($tag: String!) {
    incidences(tag: $tag) {
      productCode
      upc
      pieces
      expiryDate
      batch
    }
  }
`;

const GET_OPEN_REPORT = gql`
  query openReport {
    openReport {
      id
      label
    }
  }
`

export { VALIDATE_PRODUCT, CREATE_LOCATION_COUNTING, GET_ENABLED_LOCATIONS, GET_LATEST_VERSION, GET_OPEN_REPORT };
